<template>
    <el-dialog style="text-align: center" title="导入客户资源" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-steps :active="active" finish-status="success" align-center style="margin-bottom: 50px">
            <el-step title="步骤 1" description="选择地区" icon="el-icon-edit"></el-step>
            <el-step title="步骤 2" description="选择上传文件" icon="el-icon-upload"></el-step>
            <!--<el-step title="步骤 3" description="反馈结果" icon="el-icon-picture"></el-step>-->
        </el-steps>
        <el-form v-if="active == 0" size="small" :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="省市区">
                <el-select @change="provinceChange" v-model="formInline.province_name" filterable  placeholder="请选择省份">
                    <el-option
                            v-for="item in province_options"
                            :key="item.id"
                            :label="item.name"
                            :value="item">
                    </el-option>
                </el-select>
                <el-select @change="cityChange" v-model="formInline.city_name" filterable placeholder="请选择城市" :disabled="lock_city">
                    <el-option
                            v-for="item in city_options"
                            :key="item.id"
                            :label="item.name"
                            :value="item">
                    </el-option>
                </el-select>
                <el-select @change="regionChange" v-model="formInline.region_name" filterable placeholder="请选择区域" :disabled="lock_region">
                    <el-option
                            v-for="item in region_options"
                            :key="item.id"
                            :label="item.name"
                            :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div v-if="active ==1">
            <el-upload
                    class="upload-demo"
                    drag
                    ref="upload"
                    :on-success="onSuccess"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    :on-exceed="onExceed"
                    :on-remove="onRemove"
                    :on-change="onChange"
                    :before-remove="beforeRemove"
                    :action="action"
                    :with-credentials="true"
                    :disabled="dis"
                    :data="addons"
                    :limit="max_upload"
                    :auto-upload="false"
                    multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip"></div>
            </el-upload>
        </div>
       <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>-->

        <el-button v-if="active == 1" :disabled="lock_next" @click="prev" style="margin-top: 12px;">上一步</el-button>
        <el-button v-if="active == 0" type="primary" :disabled="lock_next" style="margin-top: 12px;" @click="next">下一步</el-button>
        <el-button v-if="active == 1" type="primary" :disabled="lock_upload" style="margin-top: 12px;" @click="submitUpload">下一步</el-button>

    </el-dialog>
</template>

<script>
    import CustomerApi from '@/api/customer.js';
    export default {
        data() {
            return {
                /*是否显示*/
                loading: false,
                dialogVisible: false,
                /* 上传文件后缀白名单 */
                domin:['xlsx','xls'],
                /* 上传文件大小限制  mb */
                max_size:'10',
                formInline:{},
                province_options:{},
                city_options:{},
                region_options:{},
                /* 城市锁 */
                lock_city:true,
                /* 区域锁 */
                lock_region:true,
                /* 下一步锁 */
                lock_next:true,
                /* 上传锁 */
                lock_upload:true,
                dis:true,
                active: 0,
                /* 最大上传个数 */
                max_upload:1,
                addons:{},
                action:''
            };
        },
        created() {
            this.dialogVisible = this.$parent.open_upload;
            this.getAddressList();
            this.upload_url()
        },
        methods: {
            upload_url(){
                CustomerApi.uploadUrl('',true)
                    .then(data => {
                        this.action = 'http://' + data.data.list + '/shop/plus.customer.customer/excel_upload'
                        console.log(this.action)
                    })
                    .catch(error => {

                    });
            },

            next() {
                if (this.active++ > 2) this.active = 0;
            },
            prev(){
                this.lock_upload = true
                --this.active
                if(this.active < 0) this.active = 0
            },

            submitUpload() {
                this.addons.region_id = this.formInline.region_id
                this.addons.province_id = this.formInline.province_id
                this.addons.city_id = this.formInline.city_id
                this.$refs.upload.submit();
            },
            onChange(file,fileList){
                this.lock_upload = false
                console.log(file)
                console.log(fileList)
            },

            onSuccess(response,file,fileList){
                let self = this
                console.log(response)
               // this.active++;
                this.lock_upload = true
                this.dialogVisible = false
                this.$notify({
                    title: '成功',
                    message: '导入成功',
                    type: 'success'
                });
                this.$parent.getTableList();
                return false;
            },
            beforeUpload(file){
             //   console.log(file)
                let self = this
                let dof = file.name.split('.')
                if (self.domin.indexOf(dof[1]) < 0){
                    this.$message({
                        type: 'info',
                        message: '不被允许的格式'
                    });
                    return false;
                }
                if ((self.max_size)*1024*1024 < file.size){
                    this.$message({
                        type: 'info',
                        message: '文件最大只允许' + self.max_size + "mb"
                    });
                    return false;
                }
            },
            beforeRemove(file,fileList){
                if(fileList.length == 1){
                    this.lock_upload = true
                }
            },
            onRemove(file,fileList){
                if(fileList.length == 0){
                    this.lock_upload = true
                }
            },
            /* 文件上传失败时的钩子	 */
            onError(){
                this.$message({
                    type: 'info',
                    message: '文件上传失败'
                });
                this.lock_upload = true
                return false;
            },
            /* 文件超出个数限制时的钩子	 */
            onExceed(){
                this.$message({
                    type: 'info',
                    message: '最大上传文件个数为'+this.max_upload+"个"
                });
                return false;
            },
            /* 省市区 */
            getAddressList(){
                let self = this;
                CustomerApi.provinceList('',true)
                    .then(data => {
                        console.log(data)
                        self.province_options = data.data.list;
                    })
                    .catch(error => {

                    })
            },
            /* 省 */
            provinceChange(selVal){
                let self = this
                /* 判断锁 */
                if (!self.lock_city){
                    self.formInline.city_name = ''
                    self.formInline.city_id = ''
                    self.lock_region = true
                    self.formInline.region_name = ''
                    self.formInline.region_id = ''
                }
                self.dis = true
                self.lock_city = false
                self.lock_next = true
                self.formInline. province_name = selVal.name
                self.formInline. province_id = selVal.id
                self.cityList(selVal.id)
            },
            /* 市列表 */
            cityList(id){
                let self = this;
                let Params = {}
                Params.province_id = id
                CustomerApi.city_list(Params,true)
                    .then(data => {
                        self.city_options = data.data.list
                    })
                    .catch(error =>{

                    });
            },
            cityChange(selVal){
                let self = this
                if (!self.lock_region){
                    self.formInline.region_name = ''
                    self.formInline.region_id = ''
                }
                self.dis = true
                self.lock_region = false
                self.lock_next = true
                self.formInline.city_name = selVal.name
                self.formInline.city_id = selVal.id
                self.regionList(selVal.id);
            },
            /* 区域 */
            regionList(id){
                let self = this;
                let Params = {}
                Params.region_id = id
                CustomerApi.region_list(Params,true)
                    .then(data => {
                        console.log(data)
                        self.region_options = data.data.list
                    })
                    .catch(error =>{

                    });
            },
            regionChange(selVal){
                let self = this
                self.formInline.region_name = selVal.name
                self.formInline.region_id = selVal.id
                /* 层级太深，需要手动刷新渲染 */
                self.$forceUpdate();
                self.dis = false
                self.lock_next = false


                console.log(self.formInline.region_name)
                console.log(self.lock_next)
            },





            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })



                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/plus/customer/customer/upload.vue